// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { countSelector, isSemUrlSelector, getIsSeoUrl } from '../../../Serp/selectors';
import { getQueryErrorText } from '../../selectors';
import ErrorNotFound from '.';
import { Router } from '../../../router';
import { trackEvent } from '../../../tracking/actions';
import {
  notFoundAdwordsImpressionEvent,
  notFoundKeywordsImpressionEvent,
  notFoundImpressionEvent,
} from '../../../tracking/events';

type Props = {
  queryText: string,
  isNotFound: boolean,
  isSeoUrl: boolean,
  isSemUrl: boolean,
  trackEvent: Function,
};

type OwnProps = {
  statusCode: number,
  routeName: ?string,
};

type MapStateToProps = {
  queryText: string,
  isNotFound: boolean,
  isSeoUrl: boolean,
  isSemUrl: boolean,
};

type MapDispatchToProps = {
  trackEvent: Function,
};

export class InnerComponent extends React.Component<Props> {
  componentDidMount() {
    Router.prefetch('/serp');
    Router.prefetch('/index');

    if (this.props.isSemUrl) {
      return this.props.trackEvent(notFoundAdwordsImpressionEvent());
    }

    if (this.props.isSeoUrl) {
      return this.props.trackEvent(notFoundKeywordsImpressionEvent());
    }

    return this.props.trackEvent(notFoundImpressionEvent());
  }

  render(): React.Node {
    return <ErrorNotFound {...this.props} />;
  }
}

export function shouldBeNotFound(
  routeName: ?string,
  count: number,
  isSeoUrl: boolean,
  statusCode: number
) {
  return routeName !== 'adpage' && count === 0 && !isSeoUrl && statusCode !== 400;
}

export const mapStateToProps = (
  state: Object,
  { statusCode, routeName }: OwnProps
): MapStateToProps => {
  const count = countSelector(state);
  const isSeoUrl = getIsSeoUrl(state);

  return {
    isSeoUrl,
    isSemUrl: isSemUrlSelector(state),
    queryText: getQueryErrorText(state),
    isNotFound: shouldBeNotFound(routeName, count, isSeoUrl, statusCode),
  };
};

export const mapDispatchToProps: MapDispatchToProps = { trackEvent };

const ErrorNotFoundContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InnerComponent);

ErrorNotFoundContainer.displayName = 'ErrorNotFoundContainer';

export default ErrorNotFoundContainer;



// WEBPACK FOOTER //
// ./app/Error/components/ErrorNotFound/container.js